const initState = {
    infoAlert: null
}

const authReducer = (state = initState, action) => {
    switch (action.type) {
        case 'SET_ALERT':
            return {
                ...state,
                infoAlert: action.infoAlert
            }
        case 'RESET_ALERT':
            return {
                ...state,
                infoAlert: null
            }
        default:
            return state
    }
}

export default authReducer